import { z } from 'zod';

import { apiPoisRoot } from '#store/apiPoisRoot.ts';

import { validateWarn } from './validateZodHelper.ts';

const TAG = 'POIS';

const customerPoiSchema = z
    .object({
        id: z.string(),
        name: z.string(),
        type: z.literal('CUSTOMER'),
        coordinates: z.object({
            latitude: z.number(),
            longitude: z.number(),
        }),
        address: z.string().optional(),
        category: z.string().optional(),
    })
    .passthrough();

const customerPoiListSchema = z
    .object({
        items: z.array(customerPoiSchema).default([]),
    })
    .passthrough();

export type ApiCustomerPoi = z.infer<typeof customerPoiSchema>;

export const poisApiSlice = apiPoisRoot.injectEndpoints({
    endpoints: build => ({
        getCustomerPois: build.query<ApiCustomerPoi[], void>({
            query: () => ({
                url: '/pois',
                method: 'GET',
                params: { type: 'CUSTOMER' },
            }),
            providesTags: [TAG],
            transformResponse: (response, meta, arg) => validateWarn(customerPoiListSchema)(response, meta, arg).items,
        }),
    }),
});

export const { useGetCustomerPoisQuery } = poisApiSlice;
